import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { QA_NAME_TOGGLE_BTN } from '../../../constants/qa'
import Button, { BUTTON_HEIGHT_32, ButtonArrow } from '../../Button'

function EntityProfileHeaderTitleToggleButton({
  className,
  height = BUTTON_HEIGHT_32,
  isOpen,
  qaName = QA_NAME_TOGGLE_BTN,
  onClick,
}) {
  return (
    <ButtonArrow
      Button={Button.Flat}
      className={className}
      closeTooltipText='Profile.HeaderCloseBtnKey'
      height={height}
      isOpen={isOpen}
      openTooltipText='Profile.HeaderOpenBtnKey'
      qaName={qaName}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={onClick}
    />
  )
}

export default EntityProfileHeaderTitleToggleButton
